<template>
    <v-content>
        <!--         Step Header         -->
        <v-row
            style="font-size: 1em; font-weight: 400; color: #212121; letter-spacing: 1px;"
            no-gutters
        >
            <v-col
                class="mx-3 text-center"
            >
                Let us help you
            </v-col>
        </v-row>
        <v-row
            justify="center"
            style="font-size: 1.2em; font-weight: 600; color: #212121; letter-spacing: 1px;"
            no-gutters
        >
            <v-col
                class="mx-3 mt-2 text-center"
            >
                What can we plan for you?
            </v-col>
        </v-row>

        <!--       Progress Tracker      -->
        <v-row
            justify="center"
            no-gutters
        >
        <v-col
            class="mx-5 pa-0"
            cols="8"
            xs="8"
            sm="6"
            md="5"
            lg="4"
            xl="4"
        >
            <v-stepper-header
                style="box-shadow: none;"
            >
            <v-stepper-step
                step="1"
                :complete="stepper > 1"
                color="#74cf74"
            />
            <v-divider></v-divider>
            <v-stepper-step
                step="2"
                :complete="stepper > 2"
                color="#74cf74"
            />
            <v-divider></v-divider>
            <v-stepper-step
                step="3"
                color="#74cf74"
            />
            </v-stepper-header>
        </v-col>
        </v-row>

        <!--            Input            -->
        <div
            class="bg5"
        >
            <v-row
                justify="center"
                no-gutters
            >
                <v-col
                    cols="12"
                    xs="12"
                    sm="10"
                    md="6"
                    lg="5"
                    xl="4"
                >
                    <v-row
                        justify="center"
                        class="mb-11"
                        no-gutters
                    >
                        <v-btn
                            class="btn3"
                            :color="mealsToPlan == 'dinners' ? '#74cf74' : 'white'"
                            @click.prevent="mealsToPlan='dinners'"
                        >
                        <v-row
                            justify="center"
                            align="center"
                            :style="mealsToPlan == 'dinners' ? 'font-size: 1em; font-weight: 600; color: #ffffff; letter-spacing: 1px' : 'font-size: 1em; font-weight: 600; color: #212121; letter-spacing: 1px'"
                            no-gutters
                        >
                            DINNERS ONLY
                        </v-row>
                        </v-btn>
                    </v-row>

                    <v-row
                        justify="center"
                        class="my-12"
                        no-gutters
                    >
                        <v-btn
                            class="btn3"
                            :color="mealsToPlan == 'all' ? '#74cf74' : 'white'"
                            @click.prevent="mealsToPlan='all'"
                        >
                        <v-col>
                            <v-row
                                justify="center"
                                align="center"
                                :style="mealsToPlan == 'all' ? 'font-size: 1em; font-weight: 600; color: #ffffff; letter-spacing: 1px' : 'font-size: 1em; font-weight: 600; color: #212121; letter-spacing: 1px'"
                                no-gutters
                            >
                                ALL MEALS AND SNACKS
                            </v-row>
                        </v-col>
                        </v-btn>
                    </v-row>
            
        <!--          Navigation         -->
                    <v-row
                        no-gutters
                        class="mx-5"
                        justify="end"
                    >
                        <v-btn
                            class="btn2 ml-2"
                            @click="next"
                            color = '#74cf74'
                            :disabled="disableStep1Next"
                        >
                            Next
                        </v-btn>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </v-content>
</template>

<script>
    export default {

        data: () => ({

        }),

        methods: {
            next() {
                this.stepper = this.stepper + 1
            }
        },

        computed: {
            stepper: {
                get() {
                    return this.$store.getters['data/stepper'];
                },
                set(value) {
                    this.$store.dispatch('data/updateStepper',value);
                }
            },

            mealsToPlan: {
                get() {
                    return this.$store.getters['data/mealsToPlan'];
                },
                set(value) {
                    this.$store.dispatch('data/updateMealsToPlan',value);
                }
            },

            disableStep1Next() {
                if (this.mealsToPlan == null | this.mealsToPlan == '') {
                    return true
                } else {
                    return false
                }
            },
            

        },
    }
</script>

<style scoped>
  .btn2 {
    font-family: "Noto Serif TC", serif;
    font-size: 0.9em;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
  }

  .btn3 {
    font-size: 0.9em;
    width: 100%;
    min-height: 48px;
    font-weight: 400;
    text-align: center;
  }

  a {
    text-decoration: none;
    color: #74cf74 !important;
    font-weight: 600;
  }
</style>

